import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import lodash from 'lodash';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    auth: {
      username: null,
      password: null,
      userInfo: null,
      roles: null,
      company: null
    },
    cart: [],
    checkout: {
      checkoutStarted: false,
      company: null,
      billingAddress: null,
      shippingAddress: null,
      comments: '',
      po: '',
      code: '',
    },
    addingToCart: false
  },
  mutations: {
    SetCredentials(state, payload) {
      state.auth.username = payload.username;
      state.auth.password = payload.password;
      state.auth.userInfo = payload.userInfo;
      state.auth.roles = payload.roles;
      if(!state.auth.company){
        debugger;
        state.auth.company = lodash.find(state.auth.userInfo.Companies, i => i.Oid === state.auth.userInfo.CompanyOid);
      }
    },
    SetProfile(state, profile) {
      state.auth.userInfo = profile;
      // if(!state.auth.company){
      //   debugger;
      //   state.auth.company = lodash.find(profile.Companies, i => i.Oid === profile.CompanyOid);
      // }
    },
    SetCompany(state, company) {
      state.auth.company = company;
    },
    ClearCredentials(state) {
      state.auth.username = null;
      state.auth.password = null;
      state.auth.userInfo = null;
      state.auth.company = null;
      state.checkout.checkoutStarted = false;
    },
    SetCartLineQuantity(state, req) {
      var existingItem = lodash.find(state.cart, (item) => {
          return item.ItemNumber == req.Product.ItemNumber;
      });

      if(existingItem) {
        existingItem.Qty = Number(req.Qty);
      }
    },
    AddToCart(state, product) {
      debugger
      if (state.addingToCart) {
        return;
      }

      state.addingToCart = true;

      var existingItem = lodash.find(state.cart, (item) => {
          return item.ItemNumber == product.ItemNumber;
      });

      if(existingItem) {
        existingItem.Qty = Number(existingItem.Qty) + Number(product.Qty);
      }
      else
      {
        var copy = Object.assign({}, product);
        state.cart.push(copy);
      }

      state.addingToCart = false;
    },
    RemoveFromCart(state, product) {
        var i = state.cart.length;
        while(i--) {
            if(state.cart[i].ItemNumber == product.ItemNumber) {
                state.cart.splice(i,1);
            }
        }
    },
    UpdateCartBillingAddress(state, address) {
      if (state.checkout.checkoutStarted) {
        state.checkout.billingAddress = address;
      }
    },
    UpdateCartShippingAddress(state, address) {
      if (state.checkout.checkoutStarted) {
        state.checkout.shippingAddress = address;
      }
    },
    EmptyCart(state) {
      state.cart = [];
    },
    ClearCart(state) {
      state.cart = [];
      state.checkout = {
        checkoutStarted: false,
        billingAddress: null,
        shippingAddress: null
      };
    },
    SetCode(state, code) {
      state.checkout.code = code;
    }
  },
  plugins: [createPersistedState()]
});

export default store;



// WEBPACK FOOTER //
// ./src/store.js